class ImpactCalculator extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-amount-input]');
    this.output = this.querySelector('[data-amount-output]');
    if (!this.input) return;
    this.formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'HKD',
      maximumFractionDigits: 0,
    });
    this.input.addEventListener('input', () => this.update());
    // Preset amount buttons elsewhere on the page target this element via commandfor.
    this.addEventListener('command', (event) => {
      if (event.command === '--set-amount') {
        this.input.value = event.source?.value || this.input.value;
        this.update();
      } else if (event.command === '--focus-slider') {
        this.input.focus();
      }
    });
    this.update();
  }

  update() {
    const amount = Number(this.input.value);
    this.output.textContent = this.formatter.format(amount);
    for (const key of ['brick', 'food', 'training']) {
      const cost = Number(this.dataset[key]) || 1;
      const el = this.querySelector(`[data-result="${key}"]`);
      if (el) el.textContent = Math.floor(amount / cost).toLocaleString();
    }
  }
}

if (!customElements.get('impact-calculator')) customElements.define('impact-calculator', ImpactCalculator);
